import { CLIENTS } from "../lib/data";

export default function ClientMarquee() {
  const items = [...CLIENTS, ...CLIENTS];
  return (
    <section data-testid="client-marquee" className="py-12 bg-white border-y border-navy/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-6">
        <p className="text-center kicker">Trusted by Industry Leaders</p>
      </div>
      <div className="marquee-wrapper relative">
        <div className="flex gap-16 whitespace-nowrap animate-marquee">
          {items.map((c, i) => (
            <span
              key={i}
              data-testid={`client-logo-${i}`}
              className="font-heading text-2xl lg:text-3xl font-bold tracking-[0.18em] text-steel-dark hover:text-navy transition-colors"
            >
              {c.toUpperCase()}
            </span>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
      </div>
    </section>
  );
}
